export default __webpack_public_path__ + "static/media/streaks 350.91a9f3f4.svg";